




import { mapState } from "vuex";
import { IState } from "@/store";
import { Vue, Component, Prop } from "vue-property-decorator";
import { IBrand } from "@/models/brands";
import { IBrandState } from "@/store/modules/brand";

@Component({
  computed: {
    ...mapState({
      storeBrand: (state: IState) => state.brand
    })
  }
})
export default class BrandLogo extends Vue {
  // Props
  @Prop({ default: "3rem" })
  public size!: string;
  // Props
  @Prop({ default: () => ({}) })
  public brand!: IBrand;

  // computed
  public storeBrand!: IBrandState;

  public get src() {
    return this.$_.get(this.logoBrand, "image.full_url", "");
  }

  public get name() {
    return this.$_.get(this.logoBrand, "name", "");
  }

  public get logoBrand() {
    return !this.$_.isEmpty(this.brand) ? this.brand : this.storeBrand;
  }
}
